// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: white;
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 80px;
  flex-shrink: 0;
}

.header__content {
  display: flex;
  align-items: center;
}

.header__title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header__icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.title-text {
  display: flex;
  flex-direction: column;
}

.header-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.user-profile-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.user-profile-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.user-profile-image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-profile-name {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-profile-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
}

.loading-skeleton-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);
  background-size: 200% 100%;
  animation: loading-shimmer 1.5s ease-in-out infinite;
}

.loading-skeleton-text {
  width: 80px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);
  background-size: 200% 100%;
  animation: loading-shimmer 1.5s ease-in-out infinite;
}

@keyframes loading-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@media (max-width: 800px) {
  .user-profile-name {
    display: none;
  }

  .user-profile-button {
    padding: 6px;
  }

  .loading-skeleton-text {
    display: none;
  }
}

.header__title {
  font-size: 24px;
  font-weight: 500;
  color: #2d3748;
}

.header__subtitle {
  font-size: 16px;
  color: #4a5568;
  font-weight: normal;
}

/* Mobile responsive styles */
@media (max-width: 800px) {
  .subtitle {
    display: none;
  }

  .button-text-full {
    display: none;
  }

  .button-text-mobile {
    display: inline;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".header {\n  background: white;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  height: 80px;\n  flex-shrink: 0;\n}\n\n.header__content {\n  display: flex;\n  align-items: center;\n}\n\n.header__title-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header__icon {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n}\n\n.title-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.user-profile-button {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.user-profile-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.user-profile-image {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-profile-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-profile-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 12px;\n}\n\n.loading-skeleton-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);\n  background-size: 200% 100%;\n  animation: loading-shimmer 1.5s ease-in-out infinite;\n}\n\n.loading-skeleton-text {\n  width: 80px;\n  height: 16px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #e2e8f0 0%, #edf2f7 50%, #e2e8f0 100%);\n  background-size: 200% 100%;\n  animation: loading-shimmer 1.5s ease-in-out infinite;\n}\n\n@keyframes loading-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@media (max-width: 800px) {\n  .user-profile-name {\n    display: none;\n  }\n\n  .user-profile-button {\n    padding: 6px;\n  }\n\n  .loading-skeleton-text {\n    display: none;\n  }\n}\n\n.header__title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.header__subtitle {\n  font-size: 16px;\n  color: #4a5568;\n  font-weight: normal;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 800px) {\n  .subtitle {\n    display: none;\n  }\n\n  .button-text-full {\n    display: none;\n  }\n\n  .button-text-mobile {\n    display: inline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
